import {FIELDS_TO_VALIDATE} from "./constants";

export class FormUtils {
  static verifyTouches = (name, touched) => {
    const fields = FIELDS_TO_VALIDATE[name]
    const touchedFields = fields.filter(field => touched[field]);
    return touchedFields.length === fields.length
  }

  static verifyErrors(name, errors) {
    const fields = FIELDS_TO_VALIDATE[name]
    const fieldsWithErrors = fields.filter(field => errors[field]);
    return fieldsWithErrors.length > 0
  }

}





// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/NewSale/utils.js